export default function stringifyValues(data: any): any {
  return data.map((obj: Record<string, any>) => {
    const result: any = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        result[key] = (() => {
          if (typeof obj[key] === "string") return obj[key];
          if (obj[key] === null) return "None";
          if (obj[key] === true) return "True";
          if (obj[key] === false) return "False";
          return JSON.stringify(obj[key]);
        })();
      }
    }
    return result;
  });
}
